import React, { createContext, useContext } from 'react';

const SectionVisibilityContext = createContext<boolean>(false);

export function SectionVisibilityProvider({ visible, children }: { visible: boolean; children: React.ReactNode }) {
    return <SectionVisibilityContext.Provider value={visible}>{children}</SectionVisibilityContext.Provider>;
}

export function useSectionVisibility() {
    return useContext(SectionVisibilityContext);
}
